module.exports = __webpack_public_path__ + "static/media/vehicle.b3b05932.png";